webpackJsonp([1],{

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(477)

var Component = __webpack_require__(54)(
  /* script */
  __webpack_require__(224),
  /* template */
  __webpack_require__(1279),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1271:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(475)

var Component = __webpack_require__(54)(
  /* script */
  __webpack_require__(226),
  /* template */
  __webpack_require__(1277),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1272:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(479)

var Component = __webpack_require__(54)(
  /* script */
  __webpack_require__(227),
  /* template */
  __webpack_require__(1282),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1273:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(478)

var Component = __webpack_require__(54)(
  /* script */
  __webpack_require__(228),
  /* template */
  __webpack_require__(1280),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1274:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(54)(
  /* script */
  __webpack_require__(229),
  /* template */
  __webpack_require__(1281),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1275:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(476)

var Component = __webpack_require__(54)(
  /* script */
  __webpack_require__(230),
  /* template */
  __webpack_require__(1278),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1276:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('router-view')], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1277:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "full-height"
  }, [_c('div', {
    staticClass: "container-fluid full-height"
  }, [_c('div', {
    staticClass: "row full-height"
  }, [_c('v-app', [_c('div', {
    staticClass: "col-md-8 full-height",
    attrs: {
      "id": "mainChartArea"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 full-height optionsTab"
  }, [_c('div', {
    staticClass: "col-md-9",
    attrs: {
      "id": "divLogo"
    }
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "id": "logo",
      "src": __webpack_require__(484),
      "alt": "Responsive image"
    }
  })]), _vm._v(" "), _c('input-section', {
    attrs: {
      "headerClass": "header",
      "subheaderClass": "white sub-header"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 titles"
  }, [_c('summary-section', {
    attrs: {
      "headerClass": "header",
      "subheaderClass": "white sub-header",
      "toolbarClass": "white toolbar-no-shadow content-color"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 titles"
  }, [_c('box-tools', {
    attrs: {
      "styleClass": "header"
    }
  })], 1)], 1)])], 1)])])
},staticRenderFns: []}

/***/ }),

/***/ 1278:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-expansion-panel', [_c('v-expansion-panel-content', {
    class: _vm.headerClass
  }, [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('v-toolbar-title', [_vm._v("Summary")])], 1), _vm._v(" "), _c('v-card', [_c('v-card-text', {
    class: _vm.subheaderClass
  }, [_vm._l((_vm.AverageTotal), function(at, index) {
    return [_c('v-toolbar', {
      class: _vm.toolbarClass,
      attrs: {
        "dense": true
      }
    }, [_vm._v("\n                            " + _vm._s(index) + "\n                            "), _c('v-spacer'), _vm._v("\n                            " + _vm._s(at) + "\n                        ")], 1)]
  })], 2)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1279:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    class: _vm.klass,
    style: (_vm.style),
    attrs: {
      "version": "1.1",
      "role": _vm.label ? 'img' : 'presentation',
      "aria-label": _vm.label,
      "x": _vm.x,
      "y": _vm.y,
      "width": _vm.width,
      "height": _vm.height,
      "viewBox": _vm.box
    }
  }, [_vm._t("default", function() {
    return [(_vm.icon && _vm.icon.paths) ? _vm._l((_vm.icon.paths), function(path, i) {
      return _c('path', _vm._b({
        key: ("path-" + i)
      }, 'path', path, false))
    }) : _vm._e(), _vm._v(" "), (_vm.icon && _vm.icon.polygons) ? _vm._l((_vm.icon.polygons), function(polygon, i) {
      return _c('polygon', _vm._b({
        key: ("polygon-" + i)
      }, 'polygon', polygon, false))
    }) : _vm._e(), _vm._v(" "), (_vm.icon && _vm.icon.raw) ? [_c('g', {
      domProps: {
        "innerHTML": _vm._s(_vm.raw)
      }
    })] : _vm._e()]
  })], 2)
},staticRenderFns: []}

/***/ }),

/***/ 1280:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "col-md-12 titles"
  }, [_c('v-toolbar', {
    class: _vm.headerClass,
    attrs: {
      "dark": ""
    }
  }, [_c('v-toolbar-title', [_vm._v("Inputs")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('label', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip:top",
      value: ({
        html: 'Upload File'
      }),
      expression: "{ html: 'Upload File' }",
      arg: "top"
    }],
    staticClass: "btn btn--icon btn--raised pointer",
    attrs: {
      "for": "file-input"
    }
  }, [_c('div', {
    staticClass: "btn__content"
  }, [_c('v-icon', [_vm._v("")])], 1)]), _vm._v(" "), _c('input', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "file-input",
      "type": "file"
    },
    on: {
      "change": function($event) {
        return _vm.uploadClick($event.target)
      }
    }
  }), _vm._v(" "), _c('v-btn', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip:top",
      value: ({
        html: 'Download File'
      }),
      expression: "{ html: 'Download File' }",
      arg: "top"
    }],
    attrs: {
      "icon": ""
    },
    on: {
      "click": _vm.downloadClick
    }
  }, [_c('v-icon', [_vm._v("")])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('v-expansion-panel', [_c('v-expansion-panel-content', {
    class: _vm.subheaderClass
  }, [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('icon', {
    attrs: {
      "name": "cubes",
      "scale": "1"
    }
  }), _vm._v(" Dimensions")], 1), _vm._v(" "), _c('v-card', [_c('v-card-text', {
    staticClass: "white content-color"
  }, [_c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', [_c('label', {
    staticClass: "col-sm-3 control-label",
    attrs: {
      "for": "xAxis"
    }
  }, [_vm._v("X Axis")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedxAxis),
      expression: "selectedxAxis"
    }],
    staticClass: "form-control select-option",
    attrs: {
      "id": "xAxis"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedxAxis = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.changexAxis()
      }]
    }
  }, _vm._l((_vm.data.valueDimensions), function(vd) {
    return _c('option', [_vm._v(_vm._s(vd.name))])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "input-dimensions"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label",
    attrs: {
      "for": "yAxis"
    }
  }, [_vm._v("Y Axis")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedyAxis),
      expression: "selectedyAxis"
    }],
    staticClass: "form-control select-option",
    attrs: {
      "id": "yAxis"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedyAxis = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.changeyAxis()
      }]
    }
  }, _vm._l((_vm.data.valueDimensions), function(vd) {
    return _c('option', [_vm._v(_vm._s(vd.name))])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "input-dimensions"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label",
    attrs: {
      "for": "size"
    }
  }, [_vm._v("Size")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedrAxis),
      expression: "selectedrAxis"
    }],
    staticClass: "form-control select-option",
    attrs: {
      "id": "size"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedrAxis = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.changerAxis()
      }]
    }
  }, [_vm._l((_vm.data.valueDimensions), function(vd) {
    return _c('option', [_vm._v(_vm._s(vd.name))])
  }), _vm._v(" "), _vm._l((_vm.additionalSizeOptions), function(value, label) {
    return _c('option', {
      key: label
    }, [_vm._v(_vm._s(label))])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "input-dimensions"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label",
    attrs: {
      "for": "colour"
    }
  }, [_vm._v("Colour")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedColour),
      expression: "selectedColour"
    }],
    staticClass: "form-control select-option",
    attrs: {
      "id": "colour"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedColour = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.changeColour()
      }]
    }
  }, _vm._l((_vm.data.categoryDimensions), function(cd) {
    return _c('option', [_vm._v(_vm._s(cd.name))])
  }), 0)])])])])])], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('v-expansion-panel', [_c('v-expansion-panel-content', {
    class: _vm.subheaderClass
  }, [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('icon', {
    attrs: {
      "name": "exchange",
      "scale": "1"
    }
  }), _vm._v(" Filter")], 1), _vm._v(" "), _c('v-card', [_c('v-card-text', {
    staticClass: "white content-color"
  }, [_c('v-btn', {
    attrs: {
      "light": "",
      "ripple": true
    },
    on: {
      "click": function($event) {
        return _vm.resetAll()
      }
    }
  }, [_vm._v("Reset All")]), _vm._v(" "), _vm._l((_vm.data.categoryDimensions), function(singleCategory, singleCategoryKey) {
    return _c('div', [_c('v-expansion-panel', {
      staticClass: "no-shadow-card"
    }, [_c('v-expansion-panel-content', {
      staticClass: "white content-color"
    }, [_c('div', {
      attrs: {
        "slot": "header"
      },
      slot: "header"
    }, [_vm._v(_vm._s(singleCategory.name))]), _vm._v(" "), _c('v-card', {
      staticClass: "no-shadow-card"
    }, [_c('v-card-text', {
      staticClass: "white content-color"
    }, [_c('v-btn', {
      staticClass: "buttonSelect",
      attrs: {
        "light": "",
        "ripple": true
      },
      on: {
        "click": function($event) {
          return _vm.selectAllClick(singleCategoryKey)
        }
      }
    }, [_vm._v("Select all")]), _vm._v(" "), _c('v-btn', {
      attrs: {
        "light": "",
        "ripple": true
      },
      on: {
        "click": function($event) {
          return _vm.selectAllClick(singleCategoryKey)
        }
      }
    }, [_vm._v("Reset")]), _vm._v(" "), _vm._l((_vm.filterData.filter[singleCategoryKey]), function(singleFilter) {
      return _c('div', [_c('div', {
        on: {
          "click": function($event) {
            return _vm.filterChart()
          }
        }
      }, [_c('v-checkbox', {
        staticClass: "check",
        attrs: {
          "tabindex": 0,
          "label": singleFilter.orderName,
          "hide-details": ""
        },
        model: {
          value: (singleFilter.isSelected),
          callback: function($$v) {
            _vm.$set(singleFilter, "isSelected", $$v)
          },
          expression: "singleFilter.isSelected"
        }
      })], 1)])
    })], 2)], 1)], 1)], 1)], 1)
  }), _vm._v(" "), _vm._l((_vm.data.valueDimensions), function(singleDimension, singleDimensionKey) {
    return _c('div', {
      on: {
        "click": function($event) {
          return _vm.sliderStart(singleDimensionKey)
        }
      }
    }, [_c('v-expansion-panel', {
      staticClass: "no-shadow-card"
    }, [_c('v-expansion-panel-content', {
      staticClass: "white content-color"
    }, [_c('div', {
      attrs: {
        "slot": "header"
      },
      slot: "header"
    }, [_vm._v(_vm._s(singleDimension.name))]), _vm._v(" "), _c('v-card', {
      staticClass: "no-shadow-card"
    }, [_c('v-card-text', {
      staticClass: "white content-color"
    }, [_c('v-btn', {
      attrs: {
        "light": "",
        "ripple": true
      },
      on: {
        "click": function($event) {
          return _vm.sliderReset(singleDimensionKey)
        }
      }
    }, [_vm._v("Reset")]), _vm._v(" "), _c('range-slider', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (true),
        expression: "true"
      }],
      ref: "slider",
      refInFor: true,
      attrs: {
        "min": _vm.filterData.filter[singleDimensionKey + _vm.data.categoryDimensions.length][0].min,
        "value": [_vm.filterData.filter[singleDimensionKey + _vm.data.categoryDimensions.length][0].values[0], _vm.filterData.filter[singleDimensionKey + _vm.data.categoryDimensions.length][0].values[1]],
        "max": _vm.filterData.filter[singleDimensionKey + _vm.data.categoryDimensions.length][0].max
      },
      on: {
        "input": function($event) {
          return _vm.sliderFilter($event, singleDimensionKey)
        }
      }
    })], 1)], 1)], 1)], 1)], 1)
  })], 2)], 1)], 1)], 1)], 1)])
},staticRenderFns: []}

/***/ }),

/***/ 1281:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._t("default"), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_vm._v("\n        " + _vm._s(_vm.rangeDescription) + "\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "row sliderarea"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('vue2-slider', {
    ref: "slider",
    attrs: {
      "real-time": true,
      "show": true,
      "speed": 0,
      "value": _vm.currentValue,
      "min": _vm.min,
      "tooltip": false,
      "max": _vm.max,
      "height": 10,
      "bgStyle": {
        'backgroundColor': '#fff',
        'boxShadow': 'inset 0.5px 0.5px 3px 1px rgba(0,0,0,.1)',
        'border': '0.1px solid #a6a6a6',
        'borderRadius': '20px'
      },
      "sliderStyle": [{
        'backgroundColor': '#00a3c4',
        'borderRadius': '5px'
      }, {
        'backgroundColor': '#032f5e',
        'borderRadius': '5px'
      }],
      "processStyle": {
        'backgroundImage': '-webkit-linear-gradient(left, #00a3c4, #032f5e)'
      }
    },
    on: {
      "click": _vm.startSlide,
      "drag-start": _vm.startSlide,
      "callback": _vm.changed,
      "drag-end": _vm.endSlide
    }
  })], 1)])], 2)
},staticRenderFns: []}

/***/ }),

/***/ 1282:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-toolbar', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.boxBool || _vm.showBoxZoom),
      expression: "boxBool || showBoxZoom"
    }],
    class: _vm.styleClass,
    attrs: {
      "dark": ""
    }
  }, [_c('v-toolbar-title', [_vm._v("Box Tools:")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip:top",
      value: ({
        html: 'Delete'
      }),
      expression: "{ html: 'Delete' }",
      arg: "top"
    }],
    attrs: {
      "icon": ""
    },
    on: {
      "click": _vm.deleteBox
    }
  }, [_c('v-icon', [_vm._v("")])], 1), _vm._v(" "), _c('v-btn', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip:top",
      value: ({
        html: 'Zoom In'
      }),
      expression: "{ html: 'Zoom In' }",
      arg: "top"
    }],
    attrs: {
      "icon": ""
    },
    on: {
      "click": _vm.zoomIn
    }
  }, [_c('v-icon', [_vm._v("")])], 1), _vm._v(" "), _c('v-btn', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip:top",
      value: ({
        html: 'Zoom Out'
      }),
      expression: "{ html: 'Zoom Out' }",
      arg: "top"
    }],
    attrs: {
      "icon": ""
    },
    on: {
      "click": _vm.zoomOut
    }
  }, [_c('v-icon', [_vm._v("")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 138:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);


var d3 = __webpack_require__(473);

var boxBool = false;
var filterOptions = {
    filter: [],
    categories: {
        names: []
    },
    catIndicies: {},
    isOrdinal: {},
    sliderMultiplier: 10000,
    sliderPower: 4,

    getCategoryIndex: function getCategoryIndex(category) {
        return this.catIndicies[category].index;
    },

    getSubCatIndex: function getSubCatIndex(category, subCategory) {
        return this.catIndicies[category].subCatIndicies[subCategory].index;
    },

    getVisibility: function getVisibility(dataPoint, categories) {

        for (var i = 0; i < categories._data.length; i++) {
            var category = categories._data[i];
            var catIndex = this.getCategoryIndex(category);

            if (this.isOrdinal[category]) {
                var subCatIndex = this.getSubCatIndex(category, dataPoint[category]);
                var filterEntry = this.filter[catIndex][subCatIndex];
                var isSelected = (typeof filterEntry === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(filterEntry)) === "object" ? filterEntry.isSelected : filterEntry;
                if (!isSelected) return false;
            } else {
                var value = dataPoint[category];
                if (value < this.filter[catIndex][0].values[0] || value > this.filter[catIndex][0].values[1]) return false;
            }
        }

        return true;
    },

    getCategoryFromIndex: function getCategoryFromIndex(categoryIndex) {
        for (var i = 0; i < this.categories.names.length; i++) {
            if (+categoryIndex === this.catIndicies[this.categories.names[i]].index) {
                return this.categories.names[i];
            }
        }

        return null;
    },

    updateOptionsDataStore: function updateOptionsDataStore(inputDimensions, data) {
        var categoryInput = inputDimensions.categoryDimensions;
        for (var i = 0; i < categoryInput.length; i++) {
            if (categoryInput[i].isImageCategory) continue;
            this.createDataForDimension(categoryInput[i], data, true);
        }

        var valueInput = inputDimensions.valueDimensions;
        for (var i = 0; i < valueInput.length; i++) {
            this.createDataForDimension(valueInput[i], data, false);
        }
    },

    createDataForDimension: function createDataForDimension(dimension, data, ordinal) {
        var outerThis = this;

        var category = dimension.name;
        this.isOrdinal[category] = {};
        this.isOrdinal[category] = ordinal;
        this.filter.push([]);
        this.categories.names.push(category);
        this.categories[category] = {};
        this.categories[category].subCategories = [];
        this.catIndicies[category] = {
            index: +(outerThis.filter.length - 1),
            subCatIndicies: {}
        };
        if (ordinal) {
            var uniqueArray = dimension.order ? dimension.order : arrayGetUnique(data.map(function (d) {
                return d[category];
            }));
            for (var j = 0; j < uniqueArray.length; j++) {
                var value = uniqueArray[j];
                if (value === null) {
                    value = "null";
                    $("#data-warning-alert").css("top", "0");
                    $("#data-warning-alert .alert").addClass("in");
                }

                this.filter[this.getCategoryIndex(category)].push(true);
                this.categories[category].subCategories.push(value);
                this.catIndicies[category].subCatIndicies[value] = {
                    index: +(outerThis.filter[outerThis.getCategoryIndex(category)].length - 1)
                };
            }
        } else {
            var values = data.map(function (d) {
                return d[category];
            });
            var min = Math.min.apply(Math, values),
                max = Math.max.apply(Math, values),
                roundTo;
            var range = max - min;
            if (range / 0.01 < 100) {
                roundTo = 2;
            } else if (range / 0.1 < 100) {
                roundTo = 1;
            } else {
                roundTo = 0;
            }

            var roundMultiplier = +("1e" + roundTo);
            min = Math.floor(min * roundMultiplier) / roundMultiplier;
            max = Math.ceil(max * roundMultiplier) / roundMultiplier;
            this.filter[this.getCategoryIndex(category)].push({
                values: [min, max],
                roundTo: roundTo,
                min: min,
                max: max,
                prefix: dimension.valueScaling.scaleFactor == 1 ? dimension.valueScaling.prefix : "",
                suffix: dimension.valueScaling.scaleFactor == 1 ? dimension.valueScaling.suffix : ""
            });
        }
    },

    getSliderOptions: function getSliderOptions(category) {
        if (this.isOrdinal[category]) return null;
        var categoryInfo = this.filter[this.getCategoryIndex(category)][0];
        var step = +("1e" + -categoryInfo.roundTo + this.sliderPower);
        var values = [categoryInfo.values[0] * this.sliderMultiplier, categoryInfo.values[1] * this.sliderMultiplier];

        return {
            animate: "ease-in-out",
            range: true,
            min: categoryInfo.values[0] * this.sliderMultiplier,
            max: categoryInfo.values[1] * this.sliderMultiplier,
            values: values,
            step: step,
            slide: function slide(event, ui) {
                var parentSelector = "#" + $(this).parents(".panel-collapse").attr("id");
                $(parentSelector + " .lower-value input").val(LCP.fn.roundTo(ui.values[0] / filterOptions.sliderMultiplier, categoryInfo.roundTo));
                $(parentSelector + " .higher-value input").val(LCP.fn.roundTo(ui.values[1] / filterOptions.sliderMultiplier, categoryInfo.roundTo));
            }
        };
    },

    isCategoryActive: function isCategoryActive(categoryIndex) {
        if (this.isOrdinal[this.getCategoryFromIndex(categoryIndex)]) {
            for (var i = 0; i < this.filter[categoryIndex].length; i++) {
                if (!this.filter[categoryIndex][i]) return true;
            }
            return false;
        }

        for (var j = 0; j < this.filter[categoryIndex].length; j++) {
            if (this.filter[categoryIndex][j].values[0] !== this.filter[categoryIndex][j].min || this.filter[categoryIndex][j].values[1] !== this.filter[categoryIndex][j].max) return true;
        }

        return false;
    }
};

function arrayGetUnique(a) {
    var output = [];
    for (var i = 0; i < a.length; i++) {
        if (!arrayFind(output, a[i])) output.push(a[i]);
    }
    return output;
}

var activeCategories = {
    _data: [],

    add: function add(category) {
        if (this._data.indexOf(category) >= 0) return;
        this._data.push(category);
    },
    remove: function remove(category) {
        var index = this._data.indexOf(category);
        if (index < 0) return;
        this._data.splice(index, 1);
    },
    clear: function clear() {
        this._data = [];
    }
};

function getFilterInputId(categoryIndex, valueIndex) {
    return categoryIndex + "_" + valueIndex + "_filter-input";
}

function getFilterItemSelector(categoryIndex, valueIndex) {
    return "#" + getFilterInputId(categoryIndex, valueIndex);
}

function getOptionsId(categoryIndex) {
    return categoryIndex + "_options";
}

function getOptionsSelector(categoryIndex) {
    return "#" + getOptionsId(categoryIndex);
}

function getCategoryHeaderId(categoryIndex) {
    return categoryIndex + "_header";
}

function getCategoryHeaderSelector(categoryIndex) {
    return "#" + getCategoryHeaderId(categoryIndex);
}

function isVisible(dataPoint) {
    if (activeCategories._data.length === 0) return true;
    return filterOptions.getVisibility(dataPoint, activeCategories);
}

function setMaxHeight(maxHeight) {
    var heightToUse;

    if (arguments.length !== 1) {
        heightToUse = 500;
    } else {
        heightToUse = maxHeight - 60;
    }

    $("#categories > .panel-body").css("max-height", heightToUse);
    $("#categories > .panel-body").css("overflow", "auto");
}

var categoryFilterControl = {
    isVisible: isVisible,
    setMaxHeight: setMaxHeight
};

var dataFile;
var data;

var defaultAnimationDuration = 1000;
var animationDuration = defaultAnimationDuration;
var titleHeight;
var summaryValuesHeight;
var boxesData = [];

var pointClickBeingHandled = false;

var selectors = {
    mainChartArea: "#mainChartArea",
    boxSummary: "#boxSummary",
    boxControls: "#summaryControlsSection",
    inputSection: "#inputSection",
    inputAccordianPanel: "#inputAccordianPanel",
    filterSection: "#filterSection",
    inputHeader: "#inputHeader",
    inputPanel: ".inputPanel",
    summaryValues: ".summaryValues"
};

var zoomAndPan = false;
var boxSelection = true;
var includeLabels = true;
var firstLoad = true;

var legendPosition = 2;

var outerWidth;
var outerHeight;
var innerWidth;
var innerHeight;

var margin = { top: 20, right: 60, bottom: 30, left: 60 };
var minAxisPaddingMultiplier = 0.9;
var maxAxisPaddingMultiplier = 1.1;

var svg;
var container;
var fullScreenBackgroundBox;
var zoomListener;

var scales = { x: "", y: "", r: "", color: "" };

var rAdditionalSizeOptions = { Enormous: 50, Huge: 20, Large: 10, Medium: 5, Small: 2, Tiny: 1, VTiny: 0.2 };
var lAdditionalLabelOption = { None: "" };

var axis = { x: "", y: "" };

var dimensions = { x: "", y: "", r: "", colorCategory: "", label: "" };
var previousColorDimension;

function arrayFind(a, b) {

    for (var i in a) {
        if (a[i] == b) return true;
    }
}

function pInt(s, mag) {
    return parseInt(s, mag || 10);
}

var defualtOptions = {
    loading: 'Loading...',
    months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
    shortMonths: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'June', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
    weekdays: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
    decimalPoint: '.',
    thousandsSep: ','
};

function numberFormat(number, decimals, decPoint, thousandsSep) {
    var n = number;
    var c = decimals;
    var d = decPoint === undefined ? defualtOptions.decimalPoint : decPoint;
    var t = thousandsSep === undefined ? defualtOptions.thousandsSep : thousandsSep,
        s = n < 0 ? "-" : "";
    var i = String(pInt(n = Math.abs(+n || 0).toFixed(c)));
    var j = i.length > 3 ? i.length % 3 : 0;

    return s + (j ? i.substr(0, j) + t : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t) + (c > 0 ? d + Math.abs(n - i).toFixed(c).slice(2) : "");
}

function arrayGetUniqueValues(a) {
    var output = [];
    for (var i = 0; i < a.length; i++) {
        if (!arrayFind(output, a[i])) output.push(a[i]);
    }
    return output;
}

function loadAll() {
    data = dataFile.data;

    initialiseDataFields();
    loadControls();
    loadChart();
    registerEventHandlers();
}

function initialiseDataFields() {

    if (data.length > 10000) animationDuration = 0;

    for (var i = 0; i < dataFile.valueDimensions.length; i++) {
        var valueDimension = dataFile.valueDimensions[i];

        dataFile[valueDimension.name] = valueDimension;
        activeCategories._data.push(valueDimension.name);

        for (var j = 0; j < dataFile.data.length; j++) {
            data[j][valueDimension.name] = data[j].values[valueDimension.index] * valueDimension.valueScaling.scaleFactor;
        }

        valueDimension.totalScaling.scaleFactor /= valueDimension.valueScaling.scaleFactor;
        valueDimension.valueScaling.scaleFactor = 1;
    }

    for (var i = 0; i < dataFile.categoryDimensions.length; i++) {
        var categoryDimension = dataFile.categoryDimensions[i];

        dataFile[categoryDimension.name] = categoryDimension;
        activeCategories._data.push(categoryDimension.name);

        for (var j = 0; j < dataFile.data.length; j++) {
            data[j][categoryDimension.name] = data[j].categories[categoryDimension.index];
        }
    }

    dimensions = {
        x: dataFile.initialX,
        y: dataFile.initialY,
        r: dataFile.initialR,
        colorCategory: dataFile.initialColour,
        label: dataFile.initialLabel
    };
    previousColorDimension = dataFile.initialColour;

    includeLabels = dataFile.includeLabels;
}

function loadControls() {
    var panelGroup = $("<div>").attr("id", "dimensionAccordian").addClass("panel-group").attr("role", "tablist").attr("aria-multiselectable", "false");

    var categoryGroup = $("<div>").addClass("panel panel-default");

    var filterHeading = $("<div>").addClass("panel-heading").attr("role", "tab").attr("id", "dimensionHeader");

    var link = $("<a>").attr("role", "button").attr("data-toggle", "collapse").attr("data-parent", "#dimensionAccordian").attr("href", "#dimensions").attr("aria-expanded", "true").attr("aria-controls", "categories");
    link.append($("<span>").append($("<i>").addClass("fa fa-cubes fa-fw").attr("aria-hidden", "true"))).append($("<span>").addClass("section-header").html("Dimensions"));

    filterHeading.append(link);
    categoryGroup.append(filterHeading);

    var filterOptionsOuter = $("<div>").attr("id", "dimensions").addClass("panel-collapse collapse in").attr("role", "tabpanel").attr("aria-labelledby", "dimensionHeader");

    var filterOptionsInner = $("<div>").addClass("panel-body").attr("id", selectors.inputAccordianPanel.replace("#", ""));

    filterOptionsOuter.append(filterOptionsInner);
    categoryGroup.append(filterOptionsOuter);
    panelGroup.append(categoryGroup);
    $(selectors.inputSection).append(panelGroup);

    loadDimensionCombo("X axis", "xAxisInput", dataFile.valueDimensions, dimensions.x, _onAxisChnaged);
    loadDimensionCombo("Y axis", "yAxisInput", dataFile.valueDimensions, dimensions.y, _onAxisChnaged);
    loadDimensionCombo("Size", "rAxisInput", dataFile.valueDimensions, dimensions.r, _onAxisChnaged, rAdditionalSizeOptions);
    loadDimensionCombo("Colour", "colourInput", dataFile.categoryDimensions, dimensions.colorCategory, _onAxisChnaged);
    if (includeLabels) loadDimensionCombo("Label", "labelInput", dataFile.categoryDimensions, dimensions.label, _onAxisChnaged, lAdditionalLabelOption);

    filterOptions.updateOptionsDataStore(dataFile, data);
    $("#dimensionAccordian").on("shown.bs.collapse hidden.bs.collapse", function (event) {
        setFilterSectionMaxHeight();
    });
}

function loadDimensionCombo(title, id, dimensions, initialValue, onChangeEvent, additionalOptions) {
    var div = $("<div>");
    div.addClass("row");
    div.addClass("comboRow");

    var titleDiv = $("<div>");
    titleDiv.addClass("col-md-3 input-title");

    titleDiv.html(title);
    div.append(titleDiv);

    var comboDiv = $("<div>");
    comboDiv.addClass("col-md-9");
    var combo = $("<form>");
    var select = $("<select>");
    select.attr("class", "dropDownList");

    var group = typeof dimensions[0].isImageCategory !== "undefined";
    if (group) {
        var imageCategories = dimensions.map(function (d) {
            return d.isImageCategory;
        });
        var unique = arrayGetUniqueValues(imageCategories);

        if (unique.length === 1 && unique[0] === false) group = false;
    }

    var parent = !group ? select : $("<optgroup>").attr("label", "User defined");

    for (var i = 0; i < dimensions.length; i++) {
        var valueDimension = dimensions[i];
        if (group && valueDimension.isImageCategory) continue;

        var option = $("<option>");
        option.html(valueDimension.name);
        option.attr("value", valueDimension.name);
        parent.append(option);
    }

    if (group) {
        select.append(parent);

        var imageGroup = $("<optgroup>").attr("label", "Images");

        for (var i = 0; i < dimensions.length; i++) {
            var valueDimension = dimensions[i];
            if (!valueDimension.isImageCategory) continue;

            var option = $("<option>");
            option.html(valueDimension.name);
            option.attr("value", valueDimension.name);
            imageGroup.append(option);
        }
        select.append(imageGroup);
    }

    if (additionalOptions == null) additionalOptions = {};

    for (var property in additionalOptions) {
        var option = $("<option>");
        option.html(property);
        option.attr("value", property);
        select.append(option);
    }

    select.val(initialValue);
    select.attr("id", id);
    select.on("change", onChangeEvent);

    comboDiv.append(combo);
    combo.append(select);

    div.append(comboDiv);

    $(selectors.inputAccordianPanel).append(div);
}

function getXaxisSelection() {
    var value = getComboValue("xAxisInput");
    return value;
}

function getYaxisSelection() {
    return getComboValue("yAxisInput");
}

function getRaxisSelection() {
    return getComboValue("rAxisInput");
}

function getColourSelection() {
    return getComboValue("colourInput");
}

function getLabelSelection() {
    return getComboValue("labelInput");
}

function getComboValue(id) {
    return $("#" + id).val();
}

function loadBoxControls() {
    $(selectors.boxControls + " .removeableControl").remove();

    var controls = $(selectors.boxControls + " ul");

    var deleteButton = $("<li>").addClass("removeableControl").append($("<i>").addClass("fa fa-trash-o"));;
    var zoomButton = $("<li>").addClass("removeableControl").append($("<i>").addClass("fa fa-expand"));
    var zoomOutButton = $("<li>").addClass("removeableControl").append($("<i>").addClass("fa fa-compress"));

    deleteButton.on("click", deleteSelectedBox);
    $(document).keyup(function (e) {
        if (e.keyCode === 8 || e.keyCode === 46) {
            deleteSelectedBox();
        }
    });
    zoomButton.on("click", zoomToSelectedBox);
    zoomOutButton.on("click", resetZoom);

    controls.append(deleteButton).append(zoomOutButton).append(zoomButton);
}

function loadChart() {

    titleHeight = 0;
    if (dataFile["title"]) {
        $("#mainChartArea").append($("<h3>").addClass("chart-title").text(dataFile["title"]));
        titleHeight = $(".chart-title").outerHeight(true);
    }

    updateChartDimensions();

    initialiseScales();
    setDomain();

    d3.select(selectors.mainChartArea).classed("plotArea", true);

    svg = d3.select(".plotArea").append("svg").attr("width", outerWidth).attr("height", outerHeight).append("g").attr("transform", "translate(" + margin.left + "," + margin.top + ")");

    container = svg;

    container.call(zoomListener);

    container.on("mousedown", handleMouseDown).on("mouseup", handleMouseUp);

    if (!zoomAndPan) {
        disableUserZoom();
    }

    fullScreenBackgroundBox = svg.append("rect").attr("width", innerWidth).attr("height", innerHeight).attr("class", "chartBackground");

    renderAxis();
    renderBoxes();
    renderData();
    renderLegend();

    populateSummaryValuesForBox(fullScreenBackgroundBox);
}

function updateChartDimensions() {

    outerWidth = $(selectors.mainChartArea).innerWidth() - 20;
    outerHeight = $(selectors.mainChartArea).innerHeight() - 20;

    innerWidth = outerWidth - margin.left - margin.right;
    innerHeight = outerHeight - margin.top - margin.bottom;
    if (dataFile["title"]) {
        outerHeight -= titleHeight;
        innerHeight -= titleHeight;
    }
}

function initialiseScales() {

    scales.x = d3.scale.linear().range([0, innerWidth]);

    scales.y = d3.scale.linear().range([innerHeight, 0]);

    scales.r = d3.scale.sqrt().range([0, 20]);
}

function setAxisDomain(dimension, axis) {

    if (rAdditionalSizeOptions[dimension] != null) {
        axis.domain([0, 20]);
        return;
    }

    var minMax = d3.extent(data, function (d) {
        return d[dimension];
    });

    var range = minMax[1] - minMax[0];
    var padding = 0.05 * range;

    if (axis === scales.r && range === 0) {
        axis.domain([0, minMax[1] > 0 ? minMax[1] * 2 : 1]);
        return;
    }

    if (minMax[0] >= 0) minMax[0] = Math.max(0, minMax[0] - padding);else minMax[0] -= padding;

    if (minMax[1] <= 0) minMax[1] = Math.min(0, minMax[1] + padding);else minMax[1] += padding;

    axis.domain(minMax).nice();
}

function setDomainForXandY() {
    var isMap = dimensions.x.toLowerCase().indexOf("lon") != -1 && dimensions.y.toLowerCase().indexOf("lat") != -1;

    setAxisDomain(dimensions.x, scales.x);
    setAxisDomain(dimensions.y, scales.y);

    if (isMap) {
        var rangeXrange = +scales.x.range()[1] - +scales.x.range()[0];
        var rangeYrange = +scales.y.range()[0] - +scales.y.range()[1];
        var rangeXdomain = +scales.x.domain()[1] - +scales.x.domain()[0];
        var rangeYdomain = +scales.y.domain()[1] - +scales.y.domain()[0];
        var xMidDomain = +scales.x.domain()[0] + 0.5 * rangeXdomain;
        var yMidDomain = +scales.y.domain()[0] + 0.5 * rangeYdomain;

        var yratio = rangeYdomain / rangeYrange;
        var xratio = rangeXdomain / rangeXrange;
        var degreeLongPerLat = 1 / Math.cos(yMidDomain * (2 * Math.PI / 360));
        var desidedXratio = yratio * degreeLongPerLat;
        var desidedYratio = xratio / degreeLongPerLat;

        if (desidedXratio > xratio) {

            var newXDomainMin = xMidDomain - 0.5 * desidedXratio * rangeXrange;
            var newXDomainMax = xMidDomain + 0.5 * desidedXratio * rangeXrange;
            scales.x.domain([newXDomainMin, newXDomainMax]);
        }

        if (desidedYratio > yratio) {

            var newYDomainMin = yMidDomain - 0.5 * desidedYratio * rangeYrange;
            var newYDomainMax = yMidDomain + 0.5 * desidedYratio * rangeYrange;
            scales.y.domain([newYDomainMin, newYDomainMax]);
        }
    }
}

function setDomain() {

    setDomainForXandY();
    setDomainsWithoutZoom();

    zoomListener = d3.behavior.zoom().x(scales.x).y(scales.y).scaleExtent([1, 10]).on("zoom", zoomHandler);
}

function setDomainsWithoutZoom() {
    setAxisDomain(dimensions.r, scales.r);

    if (dataFile[dimensions.colorCategory] && dataFile[dimensions.colorCategory].colors) {
        scales.color = d3.scale.ordinal().range(dataFile[dimensions.colorCategory].colors);
    } else {
        scales.color = d3.scale.category10();
    }

    if (dataFile[dimensions.colorCategory] && dataFile[dimensions.colorCategory].order) {
        scales.color.domain(dataFile[dimensions.colorCategory].order);
    } else {
        var domain = arrayGetUniqueValues(data.map(function (d) {
            return d[dimensions.colorCategory];
        }));
        if (domain.length === 0 || domain.length === 1 && typeof domain[0] === "undefined" || dataFile[dimensions.colorCategory].isImageCategory) return;
        scales.color.domain(domain);
    }
}

function updateDataItems() {
    var xDomain = scales.x.domain();
    var yDomain = scales.y.domain();

    $.each(data, function (i, v) {
        v.xVal = v[dimensions.x];
        v.yVal = v[dimensions.y];
        v.xR = scales.x(v.xVal);
        v.yR = scales.y(v.yVal);

        if (v.xVal < xDomain[0] || v.xVal > xDomain[1] || v.yVal < yDomain[0] || v.yVal > yDomain[1]) {
            v.rVal = 0;
        } else {
            v.rVal = v[dimensions.r];
        };

        if (v.rVal == null) v.rVal = rAdditionalSizeOptions[dimensions.r];

        v.rR = scales.r(v.rVal);

        if (v[dimensions.label] != null) v.label = v[dimensions.label];else v.label = "";

        v.colorCategory = dimensions.colorCategory;
    });
}

function renderData() {
    clearPopovers();
    updateDimensions();
    updateDataItems();

    if (enforceDelay()) cleanUp();

    if (firstLoad || !enforceDelay()) {
        plotChart();
    } else {
        setTimeout(plotChart, animationDuration);
    }

    var boxToUse = d3.selectAll(".selectedBox").size() < 1 ? fullScreenBackgroundBox : d3.select(".selectedBox");
    populateSummaryValuesForBox(boxToUse);
}

function enforceDelay() {
    if (!dataFile[previousColorDimension]) return false;
    return false;
}

function plotChart() {

    if (enforceDelay()) {
        $("defs").remove();
        $(".imageHolders").remove();
    }

    var xStart = scales.x(scales.x.domain()[0]);
    var yStart = scales.y(scales.y.domain()[0]);

    plotByCategory();
    if (includeLabels) {

        var labels = container.selectAll(".chartLabels").data(data);

        var labelLines = container.selectAll(".labelLines").data(data);

        labels.enter().append("text").attr("class", "chartLabels").attr("x", xStart).attr("y", yStart).attr("opacity", 0);

        labelLines.enter().append("line").attr("class", "labelLines").attr("x1", xStart).attr("y1", yStart).attr("x2", xStart).attr("y2", yStart);

        calculateLabelPositions();
        updateLabelPositions();
    }

    if (firstLoad) firstLoad = false;
    previousColorDimension = dimensions.colorCategory;
}

function plotByCategory() {
    var xStart = scales.x(scales.x.domain()[0]);
    var yStart = scales.y(scales.y.domain()[0]);

    var dots = container.selectAll(".dot").data(data);

    dots.enter().append("circle").attr("class", function (d) {
        return "dot";
    }).attr("stroke-width", 0).style("opacity", 0.5).attr("r", 0).attr("cx", function (d) {
        return firstLoad ? xStart : d.xR;
    }).attr("cy", function (d) {
        return firstLoad ? yStart : d.yR;
    }).style("fill", function (d) {
        return "white";
    }).style("visibility", function (d) {
        if (!categoryFilterControl.isVisible(d)) return "hidden";
        return "visible";
    }).on('mousedown', function (d, i) {
        pointClickBeingHandled = true;
        addPopUp(this);
    });

    dots.transition().duration(animationDuration).attr("cx", function (d) {
        return d.xR;
    }).attr("cy", function (d) {
        return d.yR;
    }).attr("r", function (d) {
        return d.rR;
    }).style("fill", function (d) {
        return scales.color(d[d.colorCategory]);
    }).style("visibility", function (d) {
        if (!categoryFilterControl.isVisible(d)) return "hidden";
        return "visible";
    });

    dots.exit().remove();
}

function plotByImage() {
    var xStart = scales.x(scales.x.domain()[0]);
    var yStart = scales.y(scales.y.domain()[0]);

    var imageHolders = container.selectAll(".imageHolders").data(data).enter().append("g").attr("class", "imageHolders").style("clip-path", function (d, i) {
        return "url(#path" + i + ")";
    });

    container.selectAll("defs").data(data).enter().append("defs").append("svg:clipPath").attr("id", function (d, i) {
        return "path" + i;
    }).append("rect").attr("width", function (d) {
        return firstLoad ? 1 : d.xR * 2;
    }).attr("height", function (d) {
        return firstLoad ? 1 : d.xR * 2;
    }).attr("x", function (d) {
        return firstLoad ? xStart : d.xR;
    }).attr("y", function (d) {
        return firstLoad ? yStart : d.yR;
    }).attr("class", "clipBoxes");

    imageHolders.append("image").attr("x", function (d) {
        return firstLoad ? xStart : d.xR;
    }).attr("y", function (d) {
        return firstLoad ? yStart : d.yR;
    }).attr("width", function (d) {
        return 1;
    }).attr("height", function (d) {
        return 1;
    }).attr("xlink:href", function (d) {
        return d[d.colorCategory];
    }).attr("class", "images").on('mousedown', function (d, i) {
        pointClickBeingHandled = true;
        addPopUp(this);
    });

    imageHolders = container.selectAll(".imageHolders").data(data);
    var images = container.selectAll(".images").data(data);
    var boxes = container.selectAll(".clipBoxes").data(data);

    imageHolders.transition().duration(animationDuration).style("visibility", function (d) {
        if (!categoryFilterControl.isVisible(d)) return "hidden";
        return "visible";
    });

    images.transition().duration(animationDuration).attr("x", function (d) {
        return -d.rR + d.xR;
    }).attr("y", function (d) {
        return -d.rR + d.yR;
    }).attr("width", function (d) {
        return d.rR * 2;
    }).attr("height", function (d) {
        return d.rR * 2;
    });

    boxes.transition().duration(animationDuration).attr("x", function (d) {
        return d.xR - d.rR;
    }).attr("y", function (d) {
        return d.yR - d.rR;
    }).attr("width", function (d) {
        return d.rR * 2;
    }).attr("height", function (d) {
        return d.rR * 2;
    });
}

function cleanUp() {

    container.selectAll(".images").data({}).exit().transition().duration(animationDuration).attr("x", function (d) {
        return d.xR;
    }).attr("y", function (d) {
        return d.yR;
    }).attr("height", 0).attr("width", 0).remove();
    container.selectAll(".clipBoxes").data({}).exit().transition().duration(animationDuration).attr("x", function (d) {
        return d.xR;
    }).attr("y", function (d) {
        return d.yR;
    }).attr("height", 0).attr("width", 0).remove();

    container.selectAll(".dot").data({}).exit().transition().duration(animationDuration).attr("r", 0).remove();
}

function calculateLabelPositions() {
    var labArray = [];
    var ancArray = [];

    $.each(data, function (i, v) {
        if (v.label != null) {
            labArray.push({ x: v.xR, y: v.yR, width: 100, height: 50, name: v.label, point: v });
            ancArray.push({ x: v.xR, y: v.yR, r: v.rR });
        }
    });

    d3.labeler().label(labArray).anchor(ancArray).width(innerWidth - 100).height(innerHeight - 100).start(100);

    $.each(labArray, function (i, v) {
        v.point.xL = v.x;
        v.point.yL = v.y;
    });
}

function updateLabelPositions() {
    var labels = container.selectAll(".chartLabels").data(data);
    var labelLines = container.selectAll(".labelLines").data(data);

    labels.transition().duration(animationDuration).text(function (d) {
        return d.label;
    }).attr("x", function (d) {
        return d.xL;
    }).attr("y", function (d) {
        return d.yL;
    }).attr("opacity", 1);

    labelLines.transition().duration(animationDuration).text(function (d) {
        return d.label;
    }).attr("x1", function (d) {
        return d.xR;
    }).attr("y1", function (d) {
        return d.yR;
    }).attr("x2", function (d) {
        return d.xL;
    }).attr("y2", function (d) {
        return d.yL;
    }).attr("stroke", function (d) {
        return d.colorCategory;
    }).attr("stroke-width", function (d) {
        if (d.label == "") return 0;
        return 2;
    });

    labels.exit().remove();
    labelLines.exit().remove();
}

function renderBoxes() {
    var boxes = container.selectAll(".box").data(boxesData);

    boxes.enter().append("rect").attr("class", function (d) {
        return "box";
    }).attr("x", function (d) {
        return scales.x(d.xFrom);
    }).attr("width", function (d) {
        return scales.x(d.xTo) - scales.x(d.xFrom);
    }).attr("y", function (d) {
        return scales.y(d.yTo);
    }).attr("height", function (d) {
        return scales.y(d.yFrom) - scales.y(d.yTo);
    }).attr("boxIndex", function (d, i) {
        return d.boxIndex;
    });

    boxes.transition().duration(animationDuration).attr("x", function (d) {
        return scales.x(d.xFrom);
    }).attr("width", function (d) {
        return scales.x(d.xTo) - scales.x(d.xFrom);
    }).attr("y", function (d) {
        return scales.y(d.yTo);
    }).attr("height", function (d) {
        return scales.y(d.yFrom) - scales.y(d.yTo);
    });

    boxes.exit().remove();
}

function renderLegend() {

    var legendBoxSize = 20;
    var padding = 2;
    var rowHeight = legendBoxSize + padding;
    var offsetLeft = -30;

    var legend = container.selectAll(".legend").data(scales.color.domain()).enter().append("g").attr("class", "legend").attr("transform", function (d, i) {
        switch (legendPosition) {
            case 1:
            case 2:
                return "translate(0," + (padding + i * rowHeight) + ")";

            default:
                return "translate(0," + (innerHeight + padding + (-scales.color.domain().length + i) * rowHeight) + ")";
        }
    });

    legend.append("rect").attr("x", function () {
        switch (legendPosition) {
            case 1:
            case 3:
                return padding;

            case 2:
            case 4:
            default:
                return innerWidth - offsetLeft - legendBoxSize - padding;
        }
    }).attr("width", legendBoxSize).attr("height", legendBoxSize).style("fill", scales.color);

    legend.append("text").attr("x", function () {
        switch (legendPosition) {
            case 1:
            case 3:
                return legendBoxSize + padding * 3;

            case 2:
            case 4:
            default:
                return innerWidth - legendBoxSize - offsetLeft - padding * 3;
        }
    }).attr("y", legendBoxSize / 2).attr("dy", ".35em").attr("class", "chartText").style("text-anchor", function () {
        switch (legendPosition) {
            case 1:
            case 3:
                return "start";

            default:
                return "end";
        }
    }).text(function (d) {
        return d;
    });
}

function renderAxis() {

    var xTransform = scales.y(Math.max(scales.y.domain()[0], Math.min(scales.y.domain()[1], 0)));
    var yTransform = scales.x(Math.max(scales.x.domain()[0], Math.min(scales.x.domain()[1], 0)));
    var xAboveHalfY = 0 > scales.y.domain()[0] + (scales.y.domain()[1] - scales.y.domain()[0]) / 2;
    var yAboveHalfX = 0 > scales.x.domain()[0] + (scales.x.domain()[1] - scales.x.domain()[0]) / 2;
    var xOrient, yOrient;
    if (yAboveHalfX) {
        yOrient = "right";
        if (xAboveHalfY) {
            xOrient = "top";
            legendPosition = 3;
        } else {
            xOrient = "bottom";
            legendPosition = 1;
        }
    } else {
        yOrient = "left";
        if (xAboveHalfY) {
            xOrient = "top";
            legendPosition = 4;
        } else {
            xOrient = "bottom";
            legendPosition = 2;
        }
    }

    axis.x = d3.svg.axis().scale(scales.x).orient(xOrient);

    axis.y = d3.svg.axis().scale(scales.y).orient(yOrient);

    var gxAxis = container.append("g").attr("class", "x axis chartText").attr("transform", "translate(0," + xTransform + ")").call(axis.x).append("text").attr("class", "chartText").attr("x", yOrient === "right" ? 0 : innerWidth).attr("y", -6 * (xOrient === "bottom" ? 1 : -2.5)).style("text-anchor", yOrient === "right" ? "start" : "end");

    var gyAxis = container.append("g").attr("class", "y axis chartText").attr("transform", "translate(" + yTransform + ", 0)").call(axis.y).append("text").attr("class", "chartText").attr("transform", "rotate(-90)").attr("y", 6 * (yOrient === "left" ? 1 : -2.5)).attr("x", xOrient === "bottom" ? 0 : -innerHeight).attr("dy", ".71em").style("text-anchor", xOrient === "bottom" ? "end" : "start");

    gxAxis.text(getAxisTitle(dimensions.x));
    gyAxis.text(getAxisTitle(dimensions.y));
}

function getAxisTitle(dimensionName) {
    var scaling = dataFile[dimensionName].valueScaling;

    var label = "";
    if (scaling.prefix != null) label += scaling.prefix;
    if (scaling.suffix != null) label += scaling.suffix;

    if (label.length > 0) return dimensionName + " (" + label + ")";
    return dimensionName;
}

function _onAxisChnaged() {
    resetZoom();
    updateDimensions();
    $(".axis").remove();
    $(".legend").remove();
    boxesData.length = 0;
    setDomain();
    renderData();
    renderBoxes();
    renderAxis();
    renderLegend();
}

function onDimensionChange() {
    updateDimensions();
    $(".legend").remove();
    $('.axis').remove();
    setDomain();
    renderData();
    renderLegend();
    renderAxis();
}

function updateDimensions() {
    dimensions.x = vm.$store.getters.getXaxisSelection;
    dimensions.y = vm.$store.getters.getYaxisSelection;
    dimensions.r = vm.$store.getters.getRaxisSelection;
    dimensions.colorCategory = vm.$store.getters.getColourSelection;
}

var boxIdCount = 0;

function mouseDownBoxSelect(sender) {
    var m = d3.mouse(sender);
    unselectAllBoxes();
    container.append("rect").attr("class", "box beingCreated").attr("boxId", boxIdCount).attr("x", m[0]).attr("y", m[1]).attr("xstart", m[0]).attr("ystart", m[1]).attr("width", 1).attr("height", 1);
    boxIdCount++;
    container.on("mousemove", mousemove);
}

function mousemove() {
    var currentBox = d3.select(".beingCreated");

    var m = d3.mouse(this);
    currentBox.attr("width", Math.abs(currentBox.attr("xstart") - m[0])).attr("height", Math.abs(m[1] - currentBox.attr("ystart"))).attr("x", Math.min(currentBox.attr("xstart"), m[0])).attr("y", Math.min(m[1], currentBox.attr("ystart")));
}

$(window).mouseup(function () {
    handleMouseUp();
});

function mouseUpBoxSelect(sender) {
    var currentBox = d3.select(".beingCreated");
    if (currentBox[0][0] !== null) {
        if (currentBox.attr("width") < 20 || currentBox.attr("height") < 20) {
            currentBox.remove();
            var m = d3.mouse(sender);
            selectBoxFromMousePosition(m);
        } else {
            currentBox.classed("beingCreated", false);
            currentBox.classed("selectedBox", true);
            boxBool = true;
            vm.$store.commit('updateBoxBool', boxBool);
            var newBox = {
                xFrom: scales.x.invert(currentBox.attr("x")),
                xTo: scales.x.invert(+currentBox.attr("x") + +currentBox.attr("width")),
                yFrom: scales.y.invert(+currentBox.attr("y") + +currentBox.attr("height")),
                yTo: scales.y.invert(currentBox.attr("y")),
                boxId: currentBox.attr("boxId")
            };

            boxesData.push(newBox);
            renderBoxes();
        }
    }
    container.on("mousemove", null);
}

function selectBox(rect) {
    unselectAllBoxes();
    rect.classed("selectedBox", true);
    boxBool = true;
    vm.$store.commit('updateBoxBool', boxBool);
    loadBoxControls();
    populateSummaryValuesForBox(rect);
}

function unselectAllBoxes() {
    d3.selectAll(".box").classed("selectedBox", false);
    boxBool = false;
    vm.$store.commit('updateBoxBool', boxBool);
}

function clearDiv(id) {
    $(id).empty();
}

function populateSummaryValuesForBox(box) {

    var summaryValues = getSummaryValuesForBox(box);
    vm.$store.commit('updateAverageTotal', summaryValues);
    setFilterSectionMaxHeight();
}

function getSummaryValuesForBox(box) {

    var output = new Object();

    var pointsInBox = getDataPointsInBox(box);
    var count = pointsInBox.length;
    var dimensions = dataFile.valueDimensions;

    output["Count"] = count;

    for (var dimension in dimensions) {
        dimension = dimensions[dimension];
        var dimensionName = dimension.name;
        var sum = sumDimension(pointsInBox, dimensionName);
        var average = sum / count;

        if (dimension.includeTotal) output["Total " + dimensionName] = formatValue(sum, dimension.totalScaling);
        if (dimension.includeAverage) output["Average " + dimensionName] = formatValue(average, dimension.valueScaling);
    }

    return output;
}

function formatValue(value, scaling) {

    value *= scaling.scaleFactor;

    var textValue = numberFormat(value, scaling.decimalPlaces);

    if (scaling.prefix != null) textValue = scaling.prefix + textValue;
    if (scaling.suffix != null) textValue = textValue + scaling.suffix;
    return textValue;
}

function sumDimension(points, dimension) {
    var total = 0;
    points.forEach(function (d) {
        total += d[dimension];
    });
    return total;
}

function getDataPointsInBox(box) {

    var xMin = scales.x.invert(+box.attr("x"));
    var xMax = scales.x.invert(+box.attr("x") + +box.attr("width"));
    var yMin = scales.y.invert(+box.attr("y") + +box.attr("height"));
    var yMax = scales.y.invert(+box.attr("y"));

    var pointsInBox = [];

    data.forEach(function (d) {
        var xVal = d.xVal;
        var yVal = d.yVal;
        if (xVal <= xMax && xVal >= xMin && yVal <= yMax && yVal >= yMin && categoryFilterControl.isVisible(d)) pointsInBox.push(d);
    });

    return pointsInBox;
}

function selectBoxFromMousePosition(m) {

    var xVal = m[0];
    var yVal = m[1];

    var closestBox;
    var closetdistance = 10000000;

    d3.selectAll(".box").each(function (d) {
        var rect = d3.select(this);

        if (isPointInBox(rect, xVal, yVal)) {
            var distance = Math.abs(xVal - rect.attr("x")) + Math.abs(yVal - rect.attr("y"));
            if (distance < closetdistance) {
                closestBox = rect;
                closetdistance = distance;
            }
        }
    });

    if (closestBox != null) {
        selectBox(closestBox);
    } else {
        unselectAllBoxes();
        populateSummaryValuesForBox(fullScreenBackgroundBox);
    }
    if (!pointClickBeingHandled) clearPopovers();
    pointClickBeingHandled = false;
}

function isPointInBox(box, xVal, yVal) {

    var xMin = +box.attr("x");
    var xMax = xMin + +box.attr("width");
    var yMin = +box.attr("y");
    var yMax = yMin + +box.attr("height");

    return xVal <= xMax && xVal > xMin && yVal <= yMax && yVal > yMin;
}

function deleteSelectedBox() {
    var selectedBoxElement = d3.select(".selectedBox");

    if (selectedBoxElement[0][0] === null) {
        return;
    }

    var boxId = selectedBoxElement.attr("boxId");
    var boxIndexInArray = 0;
    for (var i = 0; i < boxesData.length; i++) {
        if (boxesData[i].boxId === boxId) boxIndexInArray = i;
    }

    boxesData.splice(boxIndexInArray, 1);
    d3.select(".selectedBox").remove();
    clearDiv(selectors.boxSummary);
    populateSummaryValuesForBox(fullScreenBackgroundBox);
    boxBool = false;
    vm.$store.commit('updateBoxBool', boxBool);
}

function zoomToSelectedBox() {
    var box = d3.select(".selectedBox");
    if (box === null) {
        return;
    }
    manualZoom(box);
    unselectAllBoxes();
    d3.selectAll(".zoomedBox").classed("zoomedBox", false);
    box.classed("zoomedBox", true);
    populateSummaryValuesForBox(fullScreenBackgroundBox);
}

function resetZoom() {
    setDomain();
    svg.call(zoomListener.event);
    if (d3.selectAll(".zoomedBox").size() > 0) {
        d3.selectAll(".zoomedBox").classed("zoomedBox", false);
        populateSummaryValuesForBox(fullScreenBackgroundBox);
    }
}

function zoomHandler() {
    $(".axis").remove();
    container.select(".x.axis").call(axis.x);
    container.select(".y.axis").call(axis.y);

    renderData();
    renderBoxes();
    renderAxis();
}

function manualZoom(box) {
    if (box[0][0] === null) {
        return;
    }
    var xStartNew = +box.attr("x");
    var xEndNew = +xStartNew + +box.attr("width");

    var yStartNew = +box.attr("y") + +box.attr("height");
    var yEndNew = +box.attr("y");

    zoomListener.x(scales.x.domain([xStartNew, xEndNew].map(scales.x.invert).sort(function (a, b) {
        return a - b;
    })));
    zoomListener.y(scales.y.domain([yStartNew, yEndNew].map(scales.y.invert).sort(function (a, b) {
        return a - b;
    })));

    svg.call(zoomListener.event);
}

function addPopUp(d) {

    clearPopovers();

    var dataForPoint = d.__data__;

    if (dataForPoint == null) return;

    var list = $("<ul>");

    for (var dimensionId in dataFile.valueDimensions) {
        var dimensionObject = dataFile.valueDimensions[dimensionId];
        if (!dimensionObject.includeInPopout) continue;

        var value = dataForPoint[dimensionObject.name];

        var item = $("<li>").html(dimensionObject.name + " " + formatValue(value, dimensionObject.valueScaling));
        list.append(item);
    }

    for (var dimensionId in dataFile.categoryDimensions) {
        var dimensionObject = dataFile.categoryDimensions[dimensionId];

        if (!dimensionObject.includeInPopout) continue;

        var value = dataForPoint[dimensionObject.name];

        var item = $("<li>").html(dimensionObject.name + " " + value);
        list.append(item);
    }

    $(d).popover({ title: dataForPoint["id"], content: function content() {
            return "<ul>" + list.html() + "</ul>";
        }, container: "body", html: "true" });

    $(d).popover("show");
}

function clearPopovers() {
    $(".popover").popover("destroy");
}

function registerEventHandlers() {
    window.onresize = handleResize;
    $("#summaryControlsSection li.minimise-summary").on("click", function (event) {
        $(".summaryValues").collapse("toggle");
        $("#summaryControlsSection li.minimise-summary i").toggleClass("fa-rotate-180");

        setFilterSectionMaxHeight();
    });
}

function handleResize() {
    clearDiv(selectors.mainChartArea);

    animationDuration = 0;
    loadChart();
    animationDuration = defaultAnimationDuration;
}

function handleMouseUp() {
    if (boxSelection) {
        mouseUpBoxSelect(this);
    }
}

function handleMouseDown() {
    if (boxSelection) {
        mouseDownBoxSelect(this);
    }
}

function disableUserZoom() {
    svg.on("mousedown.zoom", null);
    svg.on("mousemove.zoom", null);
    svg.on("dblclick.zoom", null);
    svg.on("touchstart.zoom", null);
    svg.on("wheel.zoom", null);
    svg.on("mousewheel.zoom", null);
    svg.on("MozMousePixelScroll.zoom", null);
}

function addSummaryText(title, value) {

    var row = $("<div>").addClass("row");

    var titleDiv = $("<div>").addClass("col-md-8");
    titleDiv.html(title);
    row.append(titleDiv);
    var valDiv = $("<div>").addClass("col-md-4 valueColumn");
    valDiv.html(value);
    row.append(valDiv);
}

function setFilterSectionMaxHeight() {

    if ($(window).width() < 992) {
        categoryFilterControl.setMaxHeight();
        return;
    }

    var remainingHeight = $(selectors.inputPanel).outerHeight(true) - $("#logo").outerHeight(true) - $(selectors.inputHeader).outerHeight(true) - $(selectors.inputSection).outerHeight(true) - $("#summaryBox").outerHeight(true);
    if ($(selectors.summaryValues).attr("aria-expanded") === "true") remainingHeight -= summaryValuesHeight;
    categoryFilterControl.setMaxHeight(remainingHeight);
}
function isBoxSelected() {
    var test = d3.select(".selectedBox");
    return test;
}

window.Loader = {
    loadAll: loadAll,
    updateForFilter: renderData
};

/* harmony default export */ __webpack_exports__["a"] = ({
    rAdditionalSizeOptions: rAdditionalSizeOptions,
    draw: function draw(_data) {
        dataFile = _data;
        loadAll();
        plotChart();
        vm.$store.commit('updateChartFilter', filterOptions);
    },
    zoomIn: function zoomIn() {
        zoomToSelectedBox();
    },
    zoomOut: function zoomOut() {
        resetZoom();
    },
    deleteBox: function deleteBox() {
        deleteSelectedBox();
    },
    onAxisChnaged: function onAxisChnaged() {
        _onAxisChnaged();
    },
    filterChart: function filterChart() {
        plotChart();
    }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(132)))

/***/ }),

/***/ 194:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(jQuery) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);


+function ($) {
  'use strict';

  var Popover = function Popover(element, options) {
    this.init('popover', element, options);
  };

  if (!$.fn.tooltip) throw new Error('Popover requires tooltip.js');

  Popover.VERSION = '3.3.7';

  Popover.DEFAULTS = $.extend({}, $.fn.tooltip.Constructor.DEFAULTS, {
    placement: 'right',
    trigger: 'click',
    content: '',
    template: '<div class="popover" role="tooltip"><div class="arrow"></div><h3 class="popover-title"></h3><div class="popover-content"></div></div>'
  });

  Popover.prototype = $.extend({}, $.fn.tooltip.Constructor.prototype);

  Popover.prototype.constructor = Popover;

  Popover.prototype.getDefaults = function () {
    return Popover.DEFAULTS;
  };

  Popover.prototype.setContent = function () {
    var $tip = this.tip();
    var title = this.getTitle();
    var content = this.getContent();

    $tip.find('.popover-title')[this.options.html ? 'html' : 'text'](title);
    $tip.find('.popover-content').children().detach().end()[this.options.html ? typeof content == 'string' ? 'html' : 'append' : 'text'](content);

    $tip.removeClass('fade top bottom left right in');

    if (!$tip.find('.popover-title').html()) $tip.find('.popover-title').hide();
  };

  Popover.prototype.hasContent = function () {
    return this.getTitle() || this.getContent();
  };

  Popover.prototype.getContent = function () {
    var $e = this.$element;
    var o = this.options;

    return $e.attr('data-content') || (typeof o.content == 'function' ? o.content.call($e[0]) : o.content);
  };

  Popover.prototype.arrow = function () {
    return this.$arrow = this.$arrow || this.tip().find('.arrow');
  };

  function Plugin(option) {
    return this.each(function () {
      var $this = $(this);
      var data = $this.data('bs.popover');
      var options = (typeof option === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(option)) == 'object' && option;

      if (!data && /destroy|hide/.test(option)) return;
      if (!data) $this.data('bs.popover', data = new Popover(this, options));
      if (typeof option == 'string') data[option]();
    });
  }

  var old = $.fn.popover;

  $.fn.popover = Plugin;
  $.fn.popover.Constructor = Popover;

  $.fn.popover.noConflict = function () {
    $.fn.popover = old;
    return this;
  };
}(jQuery);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(132)))

/***/ }),

/***/ 195:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(jQuery) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);


+function ($) {
  'use strict';

  var Tooltip = function Tooltip(element, options) {
    this.type = null;
    this.options = null;
    this.enabled = null;
    this.timeout = null;
    this.hoverState = null;
    this.$element = null;
    this.inState = null;

    this.init('tooltip', element, options);
  };

  Tooltip.VERSION = '3.3.7';

  Tooltip.TRANSITION_DURATION = 150;

  Tooltip.DEFAULTS = {
    animation: true,
    placement: 'top',
    selector: false,
    template: '<div class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>',
    trigger: 'hover focus',
    title: '',
    delay: 0,
    html: false,
    container: false,
    viewport: {
      selector: 'body',
      padding: 0
    }
  };

  Tooltip.prototype.init = function (type, element, options) {
    this.enabled = true;
    this.type = type;
    this.$element = $(element);
    this.options = this.getOptions(options);
    this.$viewport = this.options.viewport && $($.isFunction(this.options.viewport) ? this.options.viewport.call(this, this.$element) : this.options.viewport.selector || this.options.viewport);
    this.inState = { click: false, hover: false, focus: false };

    if (this.$element[0] instanceof document.constructor && !this.options.selector) {
      throw new Error('`selector` option must be specified when initializing ' + this.type + ' on the window.document object!');
    }

    var triggers = this.options.trigger.split(' ');

    for (var i = triggers.length; i--;) {
      var trigger = triggers[i];

      if (trigger == 'click') {
        this.$element.on('click.' + this.type, this.options.selector, $.proxy(this.toggle, this));
      } else if (trigger != 'manual') {
        var eventIn = trigger == 'hover' ? 'mouseenter' : 'focusin';
        var eventOut = trigger == 'hover' ? 'mouseleave' : 'focusout';

        this.$element.on(eventIn + '.' + this.type, this.options.selector, $.proxy(this.enter, this));
        this.$element.on(eventOut + '.' + this.type, this.options.selector, $.proxy(this.leave, this));
      }
    }

    this.options.selector ? this._options = $.extend({}, this.options, { trigger: 'manual', selector: '' }) : this.fixTitle();
  };

  Tooltip.prototype.getDefaults = function () {
    return Tooltip.DEFAULTS;
  };

  Tooltip.prototype.getOptions = function (options) {
    options = $.extend({}, this.getDefaults(), this.$element.data(), options);

    if (options.delay && typeof options.delay == 'number') {
      options.delay = {
        show: options.delay,
        hide: options.delay
      };
    }

    return options;
  };

  Tooltip.prototype.getDelegateOptions = function () {
    var options = {};
    var defaults = this.getDefaults();

    this._options && $.each(this._options, function (key, value) {
      if (defaults[key] != value) options[key] = value;
    });

    return options;
  };

  Tooltip.prototype.enter = function (obj) {
    var self = obj instanceof this.constructor ? obj : $(obj.currentTarget).data('bs.' + this.type);

    if (!self) {
      self = new this.constructor(obj.currentTarget, this.getDelegateOptions());
      $(obj.currentTarget).data('bs.' + this.type, self);
    }

    if (obj instanceof $.Event) {
      self.inState[obj.type == 'focusin' ? 'focus' : 'hover'] = true;
    }

    if (self.tip().hasClass('in') || self.hoverState == 'in') {
      self.hoverState = 'in';
      return;
    }

    clearTimeout(self.timeout);

    self.hoverState = 'in';

    if (!self.options.delay || !self.options.delay.show) return self.show();

    self.timeout = setTimeout(function () {
      if (self.hoverState == 'in') self.show();
    }, self.options.delay.show);
  };

  Tooltip.prototype.isInStateTrue = function () {
    for (var key in this.inState) {
      if (this.inState[key]) return true;
    }

    return false;
  };

  Tooltip.prototype.leave = function (obj) {
    var self = obj instanceof this.constructor ? obj : $(obj.currentTarget).data('bs.' + this.type);

    if (!self) {
      self = new this.constructor(obj.currentTarget, this.getDelegateOptions());
      $(obj.currentTarget).data('bs.' + this.type, self);
    }

    if (obj instanceof $.Event) {
      self.inState[obj.type == 'focusout' ? 'focus' : 'hover'] = false;
    }

    if (self.isInStateTrue()) return;

    clearTimeout(self.timeout);

    self.hoverState = 'out';

    if (!self.options.delay || !self.options.delay.hide) return self.hide();

    self.timeout = setTimeout(function () {
      if (self.hoverState == 'out') self.hide();
    }, self.options.delay.hide);
  };

  Tooltip.prototype.show = function () {
    var e = $.Event('show.bs.' + this.type);

    if (this.hasContent() && this.enabled) {
      this.$element.trigger(e);

      var inDom = $.contains(this.$element[0].ownerDocument.documentElement, this.$element[0]);
      if (e.isDefaultPrevented() || !inDom) return;
      var that = this;

      var $tip = this.tip();

      var tipId = this.getUID(this.type);

      this.setContent();
      $tip.attr('id', tipId);
      this.$element.attr('aria-describedby', tipId);

      if (this.options.animation) $tip.addClass('fade');

      var placement = typeof this.options.placement == 'function' ? this.options.placement.call(this, $tip[0], this.$element[0]) : this.options.placement;

      var autoToken = /\s?auto?\s?/i;
      var autoPlace = autoToken.test(placement);
      if (autoPlace) placement = placement.replace(autoToken, '') || 'top';

      $tip.detach().css({ top: 0, left: 0, display: 'block' }).addClass(placement).data('bs.' + this.type, this);

      this.options.container ? $tip.appendTo(this.options.container) : $tip.insertAfter(this.$element);
      this.$element.trigger('inserted.bs.' + this.type);

      var pos = this.getPosition();
      var actualWidth = $tip[0].offsetWidth;
      var actualHeight = $tip[0].offsetHeight;

      if (autoPlace) {
        var orgPlacement = placement;
        var viewportDim = this.getPosition(this.$viewport);

        placement = placement == 'bottom' && pos.bottom + actualHeight > viewportDim.bottom ? 'top' : placement == 'top' && pos.top - actualHeight < viewportDim.top ? 'bottom' : placement == 'right' && pos.right + actualWidth > viewportDim.width ? 'left' : placement == 'left' && pos.left - actualWidth < viewportDim.left ? 'right' : placement;

        $tip.removeClass(orgPlacement).addClass(placement);
      }

      var calculatedOffset = this.getCalculatedOffset(placement, pos, actualWidth, actualHeight);

      this.applyPlacement(calculatedOffset, placement);

      var complete = function complete() {
        var prevHoverState = that.hoverState;
        that.$element.trigger('shown.bs.' + that.type);
        that.hoverState = null;

        if (prevHoverState == 'out') that.leave(that);
      };

      $.support.transition && this.$tip.hasClass('fade') ? $tip.one('bsTransitionEnd', complete).emulateTransitionEnd(Tooltip.TRANSITION_DURATION) : complete();
    }
  };

  Tooltip.prototype.applyPlacement = function (offset, placement) {
    var $tip = this.tip();
    var width = $tip[0].offsetWidth;
    var height = $tip[0].offsetHeight;

    var marginTop = parseInt($tip.css('margin-top'), 10);
    var marginLeft = parseInt($tip.css('margin-left'), 10);

    if (isNaN(marginTop)) marginTop = 0;
    if (isNaN(marginLeft)) marginLeft = 0;

    offset.top += marginTop;
    offset.left += marginLeft;

    $.offset.setOffset($tip[0], $.extend({
      using: function using(props) {
        $tip.css({
          top: Math.round(props.top),
          left: Math.round(props.left)
        });
      }
    }, offset), 0);

    $tip.addClass('in');

    var actualWidth = $tip[0].offsetWidth;
    var actualHeight = $tip[0].offsetHeight;

    if (placement == 'top' && actualHeight != height) {
      offset.top = offset.top + height - actualHeight;
    }

    var delta = this.getViewportAdjustedDelta(placement, offset, actualWidth, actualHeight);

    if (delta.left) offset.left += delta.left;else offset.top += delta.top;

    var isVertical = /top|bottom/.test(placement);
    var arrowDelta = isVertical ? delta.left * 2 - width + actualWidth : delta.top * 2 - height + actualHeight;
    var arrowOffsetPosition = isVertical ? 'offsetWidth' : 'offsetHeight';

    $tip.offset(offset);
    this.replaceArrow(arrowDelta, $tip[0][arrowOffsetPosition], isVertical);
  };

  Tooltip.prototype.replaceArrow = function (delta, dimension, isVertical) {
    this.arrow().css(isVertical ? 'left' : 'top', 50 * (1 - delta / dimension) + '%').css(isVertical ? 'top' : 'left', '');
  };

  Tooltip.prototype.setContent = function () {
    var $tip = this.tip();
    var title = this.getTitle();

    $tip.find('.tooltip-inner')[this.options.html ? 'html' : 'text'](title);
    $tip.removeClass('fade in top bottom left right');
  };

  Tooltip.prototype.hide = function (callback) {
    var that = this;
    var $tip = $(this.$tip);
    var e = $.Event('hide.bs.' + this.type);

    function complete() {
      if (that.hoverState != 'in') $tip.detach();
      if (that.$element) {
        that.$element.removeAttr('aria-describedby').trigger('hidden.bs.' + that.type);
      }
      callback && callback();
    }

    this.$element.trigger(e);

    if (e.isDefaultPrevented()) return;

    $tip.removeClass('in');

    $.support.transition && $tip.hasClass('fade') ? $tip.one('bsTransitionEnd', complete).emulateTransitionEnd(Tooltip.TRANSITION_DURATION) : complete();

    this.hoverState = null;

    return this;
  };

  Tooltip.prototype.fixTitle = function () {
    var $e = this.$element;
    if ($e.attr('title') || typeof $e.attr('data-original-title') != 'string') {
      $e.attr('data-original-title', $e.attr('title') || '').attr('title', '');
    }
  };

  Tooltip.prototype.hasContent = function () {
    return this.getTitle();
  };

  Tooltip.prototype.getPosition = function ($element) {
    $element = $element || this.$element;

    var el = $element[0];
    var isBody = el.tagName == 'BODY';

    var elRect = el.getBoundingClientRect();
    if (elRect.width == null) {
      elRect = $.extend({}, elRect, { width: elRect.right - elRect.left, height: elRect.bottom - elRect.top });
    }
    var isSvg = window.SVGElement && el instanceof window.SVGElement;

    var elOffset = isBody ? { top: 0, left: 0 } : isSvg ? null : $element.offset();
    var scroll = { scroll: isBody ? document.documentElement.scrollTop || document.body.scrollTop : $element.scrollTop() };
    var outerDims = isBody ? { width: $(window).width(), height: $(window).height() } : null;

    return $.extend({}, elRect, scroll, outerDims, elOffset);
  };

  Tooltip.prototype.getCalculatedOffset = function (placement, pos, actualWidth, actualHeight) {
    return placement == 'bottom' ? { top: pos.top + pos.height, left: pos.left + pos.width / 2 - actualWidth / 2 } : placement == 'top' ? { top: pos.top - actualHeight, left: pos.left + pos.width / 2 - actualWidth / 2 } : placement == 'left' ? { top: pos.top + pos.height / 2 - actualHeight / 2, left: pos.left - actualWidth } : { top: pos.top + pos.height / 2 - actualHeight / 2, left: pos.left + pos.width };
  };

  Tooltip.prototype.getViewportAdjustedDelta = function (placement, pos, actualWidth, actualHeight) {
    var delta = { top: 0, left: 0 };
    if (!this.$viewport) return delta;

    var viewportPadding = this.options.viewport && this.options.viewport.padding || 0;
    var viewportDimensions = this.getPosition(this.$viewport);

    if (/right|left/.test(placement)) {
      var topEdgeOffset = pos.top - viewportPadding - viewportDimensions.scroll;
      var bottomEdgeOffset = pos.top + viewportPadding - viewportDimensions.scroll + actualHeight;
      if (topEdgeOffset < viewportDimensions.top) {
        delta.top = viewportDimensions.top - topEdgeOffset;
      } else if (bottomEdgeOffset > viewportDimensions.top + viewportDimensions.height) {
        delta.top = viewportDimensions.top + viewportDimensions.height - bottomEdgeOffset;
      }
    } else {
      var leftEdgeOffset = pos.left - viewportPadding;
      var rightEdgeOffset = pos.left + viewportPadding + actualWidth;
      if (leftEdgeOffset < viewportDimensions.left) {
        delta.left = viewportDimensions.left - leftEdgeOffset;
      } else if (rightEdgeOffset > viewportDimensions.right) {
        delta.left = viewportDimensions.left + viewportDimensions.width - rightEdgeOffset;
      }
    }

    return delta;
  };

  Tooltip.prototype.getTitle = function () {
    var title;
    var $e = this.$element;
    var o = this.options;

    title = $e.attr('data-original-title') || (typeof o.title == 'function' ? o.title.call($e[0]) : o.title);

    return title;
  };

  Tooltip.prototype.getUID = function (prefix) {
    do {
      prefix += ~~(Math.random() * 1000000);
    } while (document.getElementById(prefix));
    return prefix;
  };

  Tooltip.prototype.tip = function () {
    if (!this.$tip) {
      this.$tip = $(this.options.template);
      if (this.$tip.length != 1) {
        throw new Error(this.type + ' `template` option must consist of exactly 1 top-level element!');
      }
    }
    return this.$tip;
  };

  Tooltip.prototype.arrow = function () {
    return this.$arrow = this.$arrow || this.tip().find('.tooltip-arrow');
  };

  Tooltip.prototype.enable = function () {
    this.enabled = true;
  };

  Tooltip.prototype.disable = function () {
    this.enabled = false;
  };

  Tooltip.prototype.toggleEnabled = function () {
    this.enabled = !this.enabled;
  };

  Tooltip.prototype.toggle = function (e) {
    var self = this;
    if (e) {
      self = $(e.currentTarget).data('bs.' + this.type);
      if (!self) {
        self = new this.constructor(e.currentTarget, this.getDelegateOptions());
        $(e.currentTarget).data('bs.' + this.type, self);
      }
    }

    if (e) {
      self.inState.click = !self.inState.click;
      if (self.isInStateTrue()) self.enter(self);else self.leave(self);
    } else {
      self.tip().hasClass('in') ? self.leave(self) : self.enter(self);
    }
  };

  Tooltip.prototype.destroy = function () {
    var that = this;
    clearTimeout(this.timeout);
    this.hide(function () {
      that.$element.off('.' + that.type).removeData('bs.' + that.type);
      if (that.$tip) {
        that.$tip.detach();
      }
      that.$tip = null;
      that.$arrow = null;
      that.$viewport = null;
      that.$element = null;
    });
  };

  function Plugin(option) {
    return this.each(function () {
      var $this = $(this);
      var data = $this.data('bs.tooltip');
      var options = (typeof option === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(option)) == 'object' && option;

      if (!data && /destroy|hide/.test(option)) return;
      if (!data) $this.data('bs.tooltip', data = new Tooltip(this, options));
      if (typeof option == 'string') data[option]();
    });
  }

  var old = $.fn.tooltip;

  $.fn.tooltip = Plugin;
  $.fn.tooltip.Constructor = Tooltip;

  $.fn.tooltip.noConflict = function () {
    $.fn.tooltip = old;
    return this;
  };
}(jQuery);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(132)))

/***/ }),

/***/ 196:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(1283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Home__ = __webpack_require__(1271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Home___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Home__);




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
    routes: [{
        path: '/',
        name: 'Home',
        component: __WEBPACK_IMPORTED_MODULE_2__components_Home___default.a
    }, {
        path: '/loadFile/:fileName',
        component: __WEBPACK_IMPORTED_MODULE_2__components_Home___default.a,
        props: true
    }]
}));

/***/ }),

/***/ 197:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(1286);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);





__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* default */]);
var apiBaseUrl =  true ? '' : 'http://localhost:54765';

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* default */].Store({
    state: {
        PensionsData: [],
        ChartFilter: [],
        AverageTotal: [],
        XaxisSelection: '',
        YaxisSelection: '',
        RaxisSelection: '',
        ColourSelection: '',
        BoxBool: false,
        uploadMessage: ''
    },
    getters: {
        getPensionsData: function getPensionsData(state) {
            return state.PensionsData;
        },
        getAverageTotal: function getAverageTotal(state) {
            return state.AverageTotal;
        },
        getXaxisSelection: function getXaxisSelection(state) {
            return state.XaxisSelection;
        },
        getYaxisSelection: function getYaxisSelection(state) {
            return state.YaxisSelection;
        },
        getRaxisSelection: function getRaxisSelection(state) {
            return state.RaxisSelection;
        },
        getColourSelection: function getColourSelection(state) {
            return state.ColourSelection;
        },
        getChartFilter: function getChartFilter(state) {
            return state.ChartFilter;
        },
        getBoxBool: function getBoxBool(state) {
            return state.BoxBool;
        },
        getUploadMessage: function getUploadMessage(state) {
            return state.uploadMessage;
        }
    },
    mutations: {
        updatePensionsData: function updatePensionsData(state, responseData) {
            state.PensionsData = responseData;
        },
        updateAverageTotal: function updateAverageTotal(state, responseData) {
            state.AverageTotal = responseData;
        },
        updateXaxisSelection: function updateXaxisSelection(state, updateData) {
            state.XaxisSelection = updateData;
        },
        updateYaxisSelection: function updateYaxisSelection(state, updateData) {
            state.YaxisSelection = updateData;
        },
        updateRaxisSelection: function updateRaxisSelection(state, updateData) {
            state.RaxisSelection = updateData;
        },
        updateColourSelection: function updateColourSelection(state, updateData) {
            state.ColourSelection = updateData;
        },
        updateChartFilter: function updateChartFilter(state, updateData) {
            state.ChartFilter = updateData;
        },
        updateBoxBool: function updateBoxBool(state, updateData) {
            console.log(updateData);
            state.BoxBool = updateData;
        },
        updateUploadMessage: function updateUploadMessage(state, updateData) {
            state.uploadMessage = updateData;
        }
    },
    actions: {
        loadPensionsData: function loadPensionsData(_ref, fileName) {
            var commit = _ref.commit;

            return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(apiBaseUrl + '/getChartData?fileName=' + fileName).then(function (response) {
                    commit('updatePensionsData', response.data);
                    resolve();
                });
            });
        },
        uploadFile: function uploadFile(_ref2, formData) {
            var commit = _ref2.commit;

            return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post(apiBaseUrl + '/uploadFile', formData).then(function (response) {
                    commit('updateUploadMessage', response.data);
                    resolve();
                });
            });
        },
        downloadFile: function downloadFile(_ref3, fileName) {
            var commit = _ref3.commit;

            window.open(apiBaseUrl + '/downloadFile?fileName=' + fileName, '_self');
        }
    }
}));

/***/ }),

/***/ 199:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 200:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 201:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 203:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(474)

var Component = __webpack_require__(54)(
  /* script */
  __webpack_require__(225),
  /* template */
  __webpack_require__(1276),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 223:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_polyfill__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuetify__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuetify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vuetify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_bootstrap_lcp_css_bootstrap_css__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_bootstrap_lcp_css_bootstrap_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__assets_bootstrap_lcp_css_bootstrap_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_bootstrap_lcp_js_tooltip_js__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_bootstrap_lcp_js_popover_js__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vuetify_dist_vuetify_min_css__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vuetify_dist_vuetify_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vuetify_dist_vuetify_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__assets_material_icons_lcp_css__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__assets_material_icons_lcp_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__assets_material_icons_lcp_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_awesome_components_Icon__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_awesome_components_Icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_vue_awesome_components_Icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue_awesome_icons__ = __webpack_require__(202);








__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].config.productionTip = false;





__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_5_vuetify___default.a);





__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].component('icon', __WEBPACK_IMPORTED_MODULE_11_vue_awesome_components_Icon___default.a);


window.vm = new __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */]({
    el: '#app',
    store: __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */],
    router: __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */],
    template: '<App/>',
    components: { App: __WEBPACK_IMPORTED_MODULE_2__App___default.a }
});

/***/ }),

/***/ 224:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);



var icons = {};

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'fa-icon',
  props: {
    name: {
      type: String,
      validator: function validator(val) {
        if (val && !(val in icons)) {
          console.warn('Invalid prop: prop "name" is referring to an unregistered icon "' + val + '".' + '\nPlease make sure you have imported this icon before using it.');
          return false;
        }
        return true;
      }
    },
    scale: [Number, String],
    spin: Boolean,
    inverse: Boolean,
    pulse: Boolean,
    flip: {
      validator: function validator(val) {
        return val === 'horizontal' || val === 'vertical';
      }
    },
    label: String
  },
  data: function data() {
    return {
      x: false,
      y: false,
      childrenWidth: 0,
      childrenHeight: 0,
      outerScale: 1
    };
  },

  computed: {
    normalizedScale: function normalizedScale() {
      var scale = this.scale;
      scale = typeof scale === 'undefined' ? 1 : Number(scale);
      if (isNaN(scale) || scale <= 0) {
        console.warn('Invalid prop: prop "scale" should be a number over 0.', this);
        return this.outerScale;
      }
      return scale * this.outerScale;
    },
    klass: function klass() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({
        'fa-icon': true,
        'fa-spin': this.spin,
        'fa-flip-horizontal': this.flip === 'horizontal',
        'fa-flip-vertical': this.flip === 'vertical',
        'fa-inverse': this.inverse,
        'fa-pulse': this.pulse
      }, this.$options.name, true);
    },
    icon: function icon() {
      if (this.name) {
        return icons[this.name];
      }
      return null;
    },
    box: function box() {
      if (this.icon) {
        return '0 0 ' + this.icon.width + ' ' + this.icon.height;
      }
      return '0 0 ' + this.width + ' ' + this.height;
    },
    ratio: function ratio() {
      if (!this.icon) {
        return 1;
      }
      var _icon = this.icon,
          width = _icon.width,
          height = _icon.height;

      return Math.max(width, height) / 16;
    },
    width: function width() {
      return this.childrenWidth || this.icon && this.icon.width / this.ratio * this.normalizedScale || 0;
    },
    height: function height() {
      return this.childrenHeight || this.icon && this.icon.height / this.ratio * this.normalizedScale || 0;
    },
    style: function style() {
      if (this.normalizedScale === 1) {
        return false;
      }
      return {
        fontSize: this.normalizedScale + 'em'
      };
    },
    raw: function raw() {
      if (!this.icon || !this.icon.raw) {
        return null;
      }
      var raw = this.icon.raw;
      var ids = {};
      raw = raw.replace(/\s(?:xml:)?id=(["']?)([^"')\s]+)\1/g, function (match, quote, id) {
        var uniqueId = getId();
        ids[id] = uniqueId;
        return ' id="' + uniqueId + '"';
      });
      raw = raw.replace(/#(?:([^'")\s]+)|xpointer\(id\((['"]?)([^')]+)\2\)\))/g, function (match, rawId, _, pointerId) {
        var id = rawId || pointerId;
        if (!id || !ids[id]) {
          return match;
        }

        return '#' + ids[id];
      });

      return raw;
    }
  },
  mounted: function mounted() {
    var _this = this;

    if (!this.name && this.$children.length === 0) {
      console.warn('Invalid prop: prop "name" is required.');
      return;
    }

    if (this.icon) {
      return;
    }

    var width = 0;
    var height = 0;
    this.$children.forEach(function (child) {
      child.outerScale = _this.normalizedScale;

      width = Math.max(width, child.width);
      height = Math.max(height, child.height);
    });
    this.childrenWidth = width;
    this.childrenHeight = height;
    this.$children.forEach(function (child) {
      child.x = (width - child.width) / 2;
      child.y = (height - child.height) / 2;
    });
  },
  register: function register(data) {
    for (var name in data) {
      var icon = data[name];

      if (!icon.paths) {
        icon.paths = [];
      }
      if (icon.d) {
        icon.paths.push({ d: icon.d });
      }

      if (!icon.polygons) {
        icon.polygons = [];
      }
      if (icon.points) {
        icon.polygons.push({ points: icon.points });
      }

      icons[name] = icon;
    }
  },

  icons: icons
});

var cursor = 0xd4937;
function getId() {
  return 'fa-' + (cursor++).toString(16);
}

/***/ }),

/***/ 225:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'app',
    data: function data() {
        return {};
    }
});

/***/ }),

/***/ 226:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_boxTools_vue__ = __webpack_require__(1272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_boxTools_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_boxTools_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_summarySection_vue__ = __webpack_require__(1275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_summarySection_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_summarySection_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_inputSection_vue__ = __webpack_require__(1273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_inputSection_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_inputSection_vue__);






/* harmony default export */ __webpack_exports__["default"] = ({
    components: {
        boxTools: __WEBPACK_IMPORTED_MODULE_0__components_boxTools_vue___default.a,
        summarySection: __WEBPACK_IMPORTED_MODULE_1__components_summarySection_vue___default.a,
        inputSection: __WEBPACK_IMPORTED_MODULE_2__components_inputSection_vue___default.a
    }
});

/***/ }),

/***/ 227:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__eXcYteD3_js__ = __webpack_require__(138);




/* harmony default export */ __webpack_exports__["default"] = ({
    props: ['styleClass'],
    data: function data() {
        return {
            showBoxZoom: false
        };
    },
    computed: {
        boxBool: function boxBool() {
            return this.$store.getters.getBoxBool;
        }
    },
    methods: {
        zoomIn: function zoomIn() {
            __WEBPACK_IMPORTED_MODULE_0__eXcYteD3_js__["a" /* default */].zoomIn();
            this.showBoxZoom = true;
        },
        zoomOut: function zoomOut() {
            __WEBPACK_IMPORTED_MODULE_0__eXcYteD3_js__["a" /* default */].zoomOut();
            this.showBoxZoom = false;
        },
        deleteBox: function deleteBox() {
            __WEBPACK_IMPORTED_MODULE_0__eXcYteD3_js__["a" /* default */].deleteBox();
        }
    }
});

/***/ }),

/***/ 228:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__eXcYteD3_js__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_rangeSlider_vue__ = __webpack_require__(1274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_rangeSlider_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_rangeSlider_vue__);





/* harmony default export */ __webpack_exports__["default"] = ({
    components: {
        rangeSlider: __WEBPACK_IMPORTED_MODULE_1__components_rangeSlider_vue___default.a
    },
    props: ['headerClass', 'subheaderClass'],
    data: function data() {
        return {
            selectedxAxis: '',
            selectedyAxis: '',
            selectedrAxis: '',
            selectedColour: '',
            additionalSizeOptions: __WEBPACK_IMPORTED_MODULE_0__eXcYteD3_js__["a" /* default */].rAdditionalSizeOptions,
            data: '',
            filterData: [],
            selectedFileName: '',
            uploadMessage: '',
            sliderArray: []
        };
    },
    mounted: function mounted() {
        var _this = this;

        var routeData = this.$route;
        if (routeData.params && routeData.params.fileName) {
            this.selectedFileName = routeData.params.fileName;
        }
        this.$store.dispatch('loadPensionsData', this.selectedFileName).then(function (response) {
            _this.data = _this.$store.getters.getPensionsData;
            _this.$store.commit('updateXaxisSelection', _this.data.initialX);
            _this.$store.commit('updateYaxisSelection', _this.data.initialY);
            _this.$store.commit('updateRaxisSelection', _this.data.initialR);
            _this.$store.commit('updateColourSelection', _this.data.initialColour);
            __WEBPACK_IMPORTED_MODULE_0__eXcYteD3_js__["a" /* default */].draw(_this.data);
            _this.filterData = _this.$store.getters.getChartFilter;
            _this.selectedxAxis = _this.data.initialX;
            _this.selectedyAxis = _this.data.initialY;
            _this.selectedrAxis = _this.data.initialR;
            _this.selectedColour = _this.data.initialColour;
            _this.selectedFileName = _this.data.fileName;
            for (var i = 0; i < _this.data.categoryFilter.length; i++) {
                _this.filterData.filter[i] = _this.data.categoryFilter[i];
            }
            _this.$store.commit('updateChartFilter', _this.filterData);
            __WEBPACK_IMPORTED_MODULE_0__eXcYteD3_js__["a" /* default */].filterChart();
        });
    },
    methods: {
        changexAxis: function changexAxis() {
            this.$store.commit('updateXaxisSelection', this.selectedxAxis);
            __WEBPACK_IMPORTED_MODULE_0__eXcYteD3_js__["a" /* default */].onAxisChnaged();
        },
        changeyAxis: function changeyAxis() {
            this.$store.commit('updateYaxisSelection', this.selectedyAxis);
            __WEBPACK_IMPORTED_MODULE_0__eXcYteD3_js__["a" /* default */].onAxisChnaged();
        },
        changerAxis: function changerAxis() {
            this.$store.commit('updateRaxisSelection', this.selectedrAxis);
            __WEBPACK_IMPORTED_MODULE_0__eXcYteD3_js__["a" /* default */].onAxisChnaged();
        },
        changeColour: function changeColour() {
            this.$store.commit('updateColourSelection', this.selectedColour);
            __WEBPACK_IMPORTED_MODULE_0__eXcYteD3_js__["a" /* default */].onAxisChnaged();
        },
        filterChart: function filterChart() {
            __WEBPACK_IMPORTED_MODULE_0__eXcYteD3_js__["a" /* default */].filterChart();
        },
        selectAllClick: function selectAllClick(box) {
            for (var i = 0; i < this.filterData.filter[box].length; i++) {
                this.filterData.filter[box][i].isSelected = true;
            }
            this.$store.commit('updateChartFilter', this.filterData);
            this.filterChart();
        },
        sliderFilter: function sliderFilter(newValue, sliderNumber) {
            this.filterData.filter[this.data.categoryDimensions.length + sliderNumber][0].values[0] = newValue[0];
            this.filterData.filter[this.data.categoryDimensions.length + sliderNumber][0].values[1] = newValue[1];
            this.$store.commit('updateChartFilter', this.filterData);
            this.filterChart();
        },
        uploadClick: function uploadClick(uploadEvent) {
            var _this2 = this;

            var formData = new FormData();
            for (var i = 0; i < uploadEvent.files.length; i++) {
                formData.append(uploadEvent.files[i].name, uploadEvent.files[i]);
            }
            this.$store.dispatch('uploadFile', formData).then(function (response) {
                uploadEvent.value = '';
                _this2.uploadMessage = _this2.$store.getters.getUploadMessage;
                _this2.selectedFileName = _this2.uploadMessage[1];
                if (window.location.href.indexOf('/loadFile/') !== -1) {
                    var baseUrl = window.location.href.replace(_this2.$route.fullPath, '');
                    window.open(baseUrl + '/loadFile/' + _this2.selectedFileName, '_self');
                    window.location.reload();
                } else {
                    window.open(window.location.href + 'loadFile/' + _this2.selectedFileName, '_self');
                    window.location.reload();
                }
            });
        },
        downloadClick: function downloadClick() {
            this.$store.dispatch('downloadFile', this.selectedFileName);
        },
        resetAll: function resetAll() {
            for (var i = 0; i < this.data.categoryDimensions.length; i++) {
                this.selectAllClick(i);
            }
            for (var j = 0; j < this.$refs.slider.length; j++) {
                this.$refs.slider[j].$refs.slider.setCurrentValue(this.$refs.slider[j].max);
                this.$refs.slider[j].$refs.slider.setIndex(0);
            }
        },
        sliderReset: function sliderReset(key) {
            this.$refs.slider[key].$refs.slider.setCurrentValue(this.$refs.slider[key].max);
            this.$refs.slider[key].$refs.slider.setIndex(0);
        },
        sliderStart: function sliderStart(key) {
            if (this.sliderArray.indexOf(key) === -1) {
                this.$refs.slider[key].$refs.slider.refresh();
                this.sliderArray.push(key);
            }
        }
    }

});

/***/ }),

/***/ 229:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_slider_component__ = __webpack_require__(1284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_slider_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_slider_component__);




/* harmony default export */ __webpack_exports__["default"] = ({
    props: ['id', 'title', 'value', 'min', 'max', 'labels'],
    components: {
        vue2Slider: __WEBPACK_IMPORTED_MODULE_0_vue_slider_component___default.a
    },
    data: function data() {
        return {
            currentValue: [-100, 100],
            dragging: false
        };
    },
    mounted: function mounted() {
        this.currentValue = [this.min, this.max];
    },
    methods: {
        startSlide: function startSlide(event) {
            this.dragging = true;
            this.$emit('input', event.value);
        },
        endSlide: function endSlide(event) {
            this.dragging = false;
            this.$emit('input', this.currentValue);
        },
        changed: function changed(val) {
            this.currentValue = val;
            if (!this.dragging) {
                this.$emit('input', val);
            }
        },
        refresh: function refresh() {
            if (this.$refs.slider) {
                this.$refs.slider.refresh();
            }
        }
    },
    computed: {
        rangeDescription: function rangeDescription() {
            var isOnMin = this.currentValue[0] === this.min;
            var isOnMax = this.currentValue[1] === this.max;


            if (typeof this.labels === 'undefined' || this.labels.length === 0) {
                return ' ' + this.currentValue[0] + ' to ' + this.currentValue[1];
            }

            if (isOnMax) return ' >' + this.labels[this.currentValue[0] - this.min];
            if (isOnMin) return ' <' + this.labels[this.currentValue[1] - this.min];
            return ' ' + this.labels[this.currentValue[0] - this.min] + ' to ' + this.labels[this.currentValue[1] - this.min];
        }
    },
    watch: {
        'id': function id() {
            var _this = this;

            this.currentValue = [this.min, this.max];
            window.setTimeout(function () {
                _this.$refs.slider.refresh();
            }, 10);
        },
        value: function value() {
            var _this2 = this;

            if (this.currentValue !== this.value) {
                this.currentValue = this.value;
            }
            window.setTimeout(function () {
                _this2.$refs.slider.refresh();
            }, 10);
        }
    }
});

/***/ }),

/***/ 230:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    props: ['averagetotal', 'headerClass', 'subheaderClass', 'toolbarClass'],
    computed: {
        AverageTotal: function AverageTotal() {
            return this.$store.getters.getAverageTotal;
        }
    }
});

/***/ }),

/***/ 474:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 475:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 476:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 477:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 478:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 479:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 484:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/LCP_eXcYte_final.f3b5326.png";

/***/ })

},[223]);


// WEBPACK FOOTER //
// static/js/app.85b2392245d2950b4463.js